export const FETCH_CURRENT_USER = "FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_PENDING = "FETCH_CURRENT_USER_PENDING";
export const FETCH_CURRENT_USER_REJECTED = "FETCH_CURRENT_USER_REJECTED";
export const FETCH_CURRENT_USER_FULFILLED = "FETCH_CURRENT_USER_FULFILLED";
export const SET_CURRENT_USER = "SET_CURRENT_USER";